module.exports = __webpack_public_path__ + "static/7-f21e6c5263308cf86fceee093cecf0f3.gif";